import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';

@Injectable( {
  providedIn: 'root'
} )
export class PdfServiceService {

  constructor() { }

  getPdfData(): void {
    this.generatePdf();
  }

  generatePdf(): void {
    const data = document.getElementById( 'asmnt-certificate' )
    html2canvas( data ).then(
      canvas => {
        const imgWidth = 208;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        const contentDataURL = canvas.toDataURL( 'image/png' )
        const pdf = new jspdf( 'p', 'mm', 'a4' ); // A4 size page of PDF
        pdf.addImage( contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight );
        pdf.save( 'Smartify-Certificate.pdf' );
      }
    )
  }

}
